/**
 * Tray-side API surface. Mark-read (single + bulk) over the existing
 * communicator endpoint. The backend accepts `notification_id` (scalar)
 * OR `notification_ids` (array) — we branch on array-vs-scalar so the
 * audit logs stay readable.
 */
import axios from 'axios';
import { API_BASE_URL } from '@/modules/shared/constants';

interface MarkReadResponse {
  status?: string;
  data?: { updated: number; notification_ids: number[] };
  message?: string;
}

export const markRead = async (id: number | string): Promise<void> => {
  await axios.post<MarkReadResponse>(`${API_BASE_URL}/communicator/notifications/mark-read`, {
    notification_id: id,
  });
};

export const markManyRead = async (ids: Array<number | string>): Promise<void> => {
  if (!ids.length) return;
  await axios.post<MarkReadResponse>(`${API_BASE_URL}/communicator/notifications/mark-read`, {
    notification_ids: ids,
  });
};
